import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { get } from 'lodash'
import { ParticipantsPreparationTrainings } from 'containers/forms/aj-preparation-trainings'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Modal } from 'containers/misc'
import { ButtonGroup, Button, Module, AccordionToggle } from 'components/misc'
import { apiAwards } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'
import { AJ_TRAINING_PROGRESS_STATES } from 'constants/enums'
import AjPrepAndTrainingState from '../../forms/aj-preparation-trainings/AjPrepAndTrainingState'
import { connect } from 'react-redux'


@meta({
  title: 'AJ Preparation and training'
})
@apiAwards({
  detailWithoutParam: true,
  preparationTrainings: true,
  redirectToTasks: true,
  pushToParticipantDetail: true
})
@connect(
    state => ({
      award: state.api.awards.detail
    }),
    {}
)
class AjPreparationTraining extends Component {
  static propTypes = {
    awards: PropTypes.object.isRequired,
    awardId: PropTypes.number.isRequired,
    decoAwardId: PropTypes.number,
    award: PropTypes.object.isRequired,
    approveAjPreparationTraining: PropTypes.func.isRequired,
    returnAjPreparationTraining: PropTypes.func.isRequired,
    changeAjPrepAndTrainState: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      ajPrepTrainingId: null,
      ajPrepTrainingIdReturn: null
    }
  }

  state = { isVisible: false, loaded: false }

  handleToggle = () => {
    this.setState({ isVisible: !this.state.isVisible })
  }

  handleApproveParticipantEventModal = ajPrepTrainingId => {
    this.setState(
      {
        ajPrepTrainingId
      },
      () => {
        this.props.modal(`modal-approve-aj-participant-event-${this.key}`)
      }
    )
  }

  handleReturnParticipantEventModal = ajPrepTrainingIdReturn => {
    this.setState(
      {
        ajPrepTrainingIdReturn
      },
      () => {
        this.props.modal(`modal-return-aj-participant-event-${this.key}`)
      }
    )
  }

  render() {
    const {
      awards,
      award,
      approveAjPreparationTraining,
      returnAjPreparationTraining,
      changeAjPrepAndTrainState,
      awardId
    } = this.props

    const ajPrepAndTrainState = award && get(award, 'ajPreparationAndTrainingStateType')

    return (

        <Module narrow verticallyNarrow>
          <AccordionToggle
              isActive={this.state.isVisible}
              onClick={this.handleToggle}
              intlKey="aj.preparation_and_training"
          >
            Preparation and training
          </AccordionToggle>

          {this.state.isVisible && (<div style={{ border: '1px solid #d8d8d8' }}>

            <div style={{ width: '98%', margin: 'auto', marginTop: '10px', marginBottom: '10px' }}>

            <div className="row">
              <div className="col-xs-8">
              </div>
              <div className="col-xs-4">
                {get(awards, 'detail.id') &&
                <ButtonGroup right>
                  <Button
                      intlKey="button.approve"
                      onClick={() =>
                          this.handleApproveParticipantEventModal(
                              get(awards, 'detail.id')
                          )}
                      disabled={
                        get(
                            awards,
                            'detail.ajPreparationAndTrainingStateType.value'
                        ) !== AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id
                      }
                  >
                    Approve
                  </Button>
                  <Button
                      intlKey="button.revise"
                      onClick={() =>
                          this.handleReturnParticipantEventModal(
                              get(awards, 'detail.id')
                          )}
                      disabled={
                        get(
                            awards,
                            'detail.ajPreparationAndTrainingStateType.value'
                        ) !== AJ_TRAINING_PROGRESS_STATES.ajTrainingLeaderSignoff.id
                      }
                      secondary
                  >
                    Revise
                  </Button>
                </ButtonGroup>}
              </div>
            </div>
            </div>

            <ParticipantsPreparationTrainings {...this.props} />
            <Modal
                id={`modal-approve-aj-participant-event-${this.key}`}
                customActions
            >
              <TaskApprove
                  id={this.state.ajPrepTrainingId}
                  approve={approveAjPreparationTraining}
                  modal={this.props.modal}
              />
            </Modal>
            <Modal
                id={`modal-return-aj-participant-event-${this.key}`}
                customActions
            >
              <TaskReturn
                  returnTask={returnAjPreparationTraining}
                  id={this.state.ajPrepTrainingIdReturn}
                  modal={this.props.modal}
              />
            </Modal>
          </div>)}


          <div style={{ marginTop: '10px' }}>
          <AjPrepAndTrainingState
              awardId={awardId}
              ajPrepAndTrainState={ajPrepAndTrainState}
              changeAjPrepAndTrainState={changeAjPrepAndTrainState}
          />
          </div>
        </Module>
    )
  }
}

export default AjPreparationTraining
